<script setup>
import { computed, onMounted, ref } from 'vue';
import { useAlert } from 'dashboard/composables';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const axios = window.axios;

const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
});

const accountId = computed(() => window.location.pathname.split('/')[3]);
const inboxId = computed(() => props.inbox?.id);

const enabled = ref(false);
const saving = ref(false);

const settingsPath = computed(
  () => `/api/v1/accounts/${accountId.value}/public_conversation_link/settings`
);

const loadSettings = async () => {
  if (!inboxId.value) return;
  try {
    const { data } = await axios.get(settingsPath.value, {
      params: { inbox_id: inboxId.value },
    });
    enabled.value = data.enabled === true;
  } catch {
    enabled.value = false;
  } finally {
    // Update cache so PublicLink tab condition is evaluated correctly
    window.__publicConvLink?.setInboxEnabled(inboxId.value, enabled.value);
    window.dispatchEvent(new Event('chatwoot:plugin:tabs:refresh'));
  }
};

const toggle = async () => {
  if (!inboxId.value || saving.value) return;
  const newVal = !enabled.value;
  saving.value = true;
  try {
    await axios.put(settingsPath.value, {
      inbox_id: inboxId.value,
      enabled: newVal,
    });
    enabled.value = newVal;
    window.__publicConvLink?.setInboxEnabled(inboxId.value, newVal);
    window.dispatchEvent(new Event('chatwoot:plugin:tabs:refresh'));
    useAlert(newVal ? 'Public Link habilitado para este inbox.' : 'Public Link desabilitado para este inbox.');
  } catch {
    useAlert('Erro ao salvar configuração.');
  } finally {
    saving.value = false;
  }
};

onMounted(loadSettings);
</script>

<template>
  <div class="flex items-center justify-between rounded-lg border border-n-slate-4 p-4 my-4">
    <div>
      <p class="text-sm font-medium text-n-slate-12">Public Link de conversa</p>
      <p class="text-xs text-n-slate-11">
        Habilita o link público de leitura de conversas para este inbox. Padrão: desabilitado.
      </p>
    </div>
    <Switch :model-value="enabled" :disabled="saving" @update:model-value="toggle" />
  </div>
</template>
